import { useCallback } from "react";
import { useApolloClient } from "@apollo/client";

import { personTagsFragment } from "src/queries/fragments/personTagsFragment.graphql";

const useUpdatePersonTagsCache = (aggregateId) => {
  const client = useApolloClient();

  const updateTagsCache = useCallback(
    (tags) => {
      if (!aggregateId) {
        return;
      }

      try {
        // WARN: Should always make sure PERSON_TAG_TYPES load all tag types that are displayed in UI
        // The tags fragment must exist as the tags is loaded in PersonFragment

        // Read existing cache first to preserve all fields
        const existingData = client.readFragment({
          id: `Person:${aggregateId}`,
          fragment: personTagsFragment,
        });

        // Only update if fragment exists in cache
        if (existingData) {
          client.writeFragment({
            id: `Person:${aggregateId}`,
            fragment: personTagsFragment,
            data: {
              ...existingData,
              tags,
            },
          });
        }
      } catch {
        // Fragment doesn't exist in cache yet or cache is in inconsistent state
        // This is OK - the UI will refresh when the Person query completes
      }
    },
    [aggregateId, client]
  );

  return { updateTagsCache };
};

export default useUpdatePersonTagsCache;
